/* tslint:disable */
export const marketColumnsDisplay = {
    "3": {
        minWidth: 0,
        maxWidth: 1400
    }
};
//# sourceMappingURL=marketColumnsDisplay.js.map